module.exports = __webpack_public_path__ + "img/LUB00229.c6e89d36.png";